export { default as PublicPage } from './PublicPage'


// WEBPACK FOOTER //
// ./src/App/Public/index.js